import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {create as createChannel} from "app/requests/admin/channels";
import {usePrompt} from "lib/hooks";
import useAppContext from "lib/hooks/use-app-context";
import {valueFrom, valueFromTarget} from "lib/form";
import {withoutBlankValues} from "lib/object";
import Form from "./form";

export default function AdminChannelsNew() {
  const {dispatch} = useAppContext();
  const navigate = useNavigate();
  const [block, setBlock] = useState(false);
  const [channel, setChannel] = useState({
    author: "",
    description: "",
    explicit: false,
    google_categories: [],
    itunes_categories: [],
    link: "",
    owner_email: "",
    owner_name: "",
    subtitle: "",
    title: ""
  });

  usePrompt({when: block});

  const onChange = ({target}) => {
    setBlock(true);
    setChannel({...channel, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (e) => {
    e.preventDefault();

    setBlock(false);
    createChannel({channel: withoutBlankValues({...channel})}).then((data) => {
      if(data.success) {
        navigate("/admin/channels", {state: {message: data.message, type: "success"}});
      } else {
        dispatch(createNotification({content: data.message, type: "danger"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({defaultValue, name, objects: [channel]});

  return (
    <div className="container-fluid">
      <h1 className="text-center">New Channel</h1>
      <Form {...{onChange, onSubmit, value}} />
    </div>
  );
}
